<template>
    <div class="headerWrap">
        <header>
            <div class="header">
                <div class=" clearfix">
                    <div class="topLi fr">
                        <img class="topImg fl" v-if="headImg!=undefined" :src="headImg"  :onerror="defaultImg"/>
                        <span class="ml5">{{usename}}</span>
                        <a href="javascript:void(0);" class="logout ml10" @click="logOut">退出</a>
                    </div>
                    <div class="nav-menu fl">
                        <ul>
                            <li v-for="(item,index) in menuList" :key="index">
                                <router-link class="db" exact :to='item.link' v-if="item.id===1"><i class="icons fl" :class="'nav-icon'+item.id"></i>{{item.name}}</router-link>
                                <router-link class="db" :to='item.link' v-if="item.id!=1"><i class="icons fl" :class="'nav-icon'+item.id"></i>{{item.name}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>
<script>
export default {
    props: "",
    data() {
        return {
            usename:'',//用户名
            headImg:'',
            defaultImg:'this.src="static/images/img.png"',
            menuList:[
                {id:1,name:'知识图谱',link:'/'},
                {id:2,name:'事件图谱',link:'/eventMap'},
            ],
            keywords:'',
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
            that.dataAjax();
        })
    },
    methods: {
        getCookie(c_name){
          if (document.cookie.length>0){
            let c_start=document.cookie.indexOf(c_name + "=")
            if (c_start!=-1){
              c_start=c_start + c_name.length+1
              let c_end=document.cookie.indexOf(";",c_start)
              if (c_end==-1) c_end=document.cookie.length
                return unescape(document.cookie.substring(c_start,c_end))
              }
            }
          return ""
        },
        dataAjax(){
            let that = this;
            that.$api.get('user/index/info',null, r => {
                that.$parent.returnCode(r,function(){
                    that.headImg = r.data.head_img;
                    that.usename = r.data.username;
                })
            })
        },
        logOut () {
            let that = this;
            that.$parent.loadModal(true,'正在退出登录...');
            that.$api.get('user/index/logout', null, r => {
                that.$parent.returnCode(r,function(){
                    window.location.href= r.data;
                })
            })
        },
        KeyUpEsc(){
            let that = this;
            if(that.keywords==''){
                 that.$utils.alertText('输入人名/地名/公司/机构/事件关键词',300);
                return
            }
            that.$router.push({ path:'/transDetail',query:{keyword:that.keywords}})
        },
    }
}
</script>
<style lang="">
    .headerWrap{position:fixed;width:100%;height:68px;box-shadow: 0 0 2px #ddd;z-index:2;}
    .header{background:#fff;height:68px;z-index:2;padding:0 30px 0 40px}
    .top{background-color: #181818;height:36px;color:#99a5ad;padding:5px 0;line-height:26px}
    .topImg{width:36px;height:36px;border-radius:50%}
    .topLi{line-height:36px;position: relative;z-index:2;padding-top:16px;color:#525e66}
    .topLi+.topLi:before{content:'';width:1px;height:14px;background-color:rgba(116, 116, 116, .7);float:right;margin:7px 15px;}
    .logout{display: inline-block}
    .topLi p{display:none;width:134px;height: 134px;background-color: #fff;border:1px solid #ddd;top:31px;position:absolute;left:-15px;padding:10px}
    .topLi:hover p{display:block}
    .header .logo{margin:13px 50px 0 0;}
    .logo img{height:40px}
    .nav-menu li{float:left;position:relative;line-height:65px;}
    .nav-menu li a{padding: 0 25px;color:#000;font-size:16px;cursor:pointer;}
    .nav-menu li a:hover{text-decoration:none;color: #7F33D6; opacity: 0.8;}
    .nav-menu li .router-link-active:not(.active-none){border-bottom:3px solid #2799df;color: #2799df}
    .search-btn{background-color: #2799df;color:#fff;width:68px;height:40px;line-height:40px;border:none;border-radius:0 3px 3px 0 }
    .search-warp{margin:19px 0 0 25px}
    .search-warp .input-text{height:40px;border-radius:1px}
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue